import { RelatedTagsConfig } from '../../../models';
import { DeepPartial } from '../../../utils';

export const DEFAULT_RELATED_TAGS_CONFIG: DeepPartial<RelatedTagsConfig> = {
  relatedTags: {
    showScrollButtons: true
  }
};
